import './configure-packages';

import { SessionKeepAlive } from '@hugendubel/login';
import { ErrorBoundary, LoadingScreen } from '@hugendubel/react-basic';
import { ReactAppInit } from '@hugendubel/react-ws';
import { TRACK_ID, Track } from '@hugendubel/tracking_manager';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Globals } from './globals';
import { LoyaltyIFrameService } from './services/loyalty-iFrame-service';
import { Store } from './store';
import { App } from './ui/components/App';
import { FallbackPage } from './ui/components/FallbackPage';
import { Fallback } from './ui/fallback/FallbackPage';

// initialize the LoadingScreen
LoadingScreen.init();
// initialize the iFrame service
LoyaltyIFrameService.init();

const root = document.getElementById('root');

ReactAppInit.run()
    .then(() => {
        SessionKeepAlive.run();
        return (
            root &&
            ReactDOM.render(
                <StrictMode>
                    <ErrorBoundary fallback={FallbackPage}>
                        <Store.root>
                            <BrowserRouter basename="praemienshop">
                                <App />
                            </BrowserRouter>
                        </Store.root>
                    </ErrorBoundary>
                </StrictMode>,
                root
            )
        );
    })
    .catch(e => {
        Track.error(TRACK_ID('2020-09-18 02:18:52'), 'error initializing bonus shop: ' + e.message);
        Fallback.open();
    });

if (process.env.NODE_ENV === 'development') {
    Globals.window().open = (...args: Array<any>) =>
        Globals.window().console.info('would have called window.open with: ', ...args) as any;
}
